import mailHeaderStyles from "./../components/mailHeader/mailheader.module.scss";
import mailStyles from "./../components/mailList/mailItem/./mailItem.module.scss";

const tutorialSequence = [
	{
		target: "." + mailHeaderStyles["all-mails"],
		content: "Find all your received emails here",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		disableOverlayClose: true,
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "." + mailHeaderStyles["sent-mails"],
		content: "Find all the emails you have sent here",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		disableOverlayClose: true,
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#" + mailStyles.wrapper + "star0", //get first mail
		content: "Star mark emails that you consider important here. This is to help you organize better. Please note this is not scored.",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		disableOverlayClose: true,
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-filter",
		content:
			"Look at only star marked emails and the ones with attachments by filtering your emails here",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		disableOverlayClose: true,
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-timer",
		content: "Keep a track of the time left in the simulation here",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		styles: {
			options: {
				zIndex: 10000
			},
			spotlight: {
				top: "-15px"
			}
		}
	},
	{
		target: "#tutorial-help",
		content:
			"Access simulation related information and reach out for support here",
		textAlign: "center",
		placement: "bottom",
		disableBeacon: true,
		disableOverlayClose: true,
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#" + mailStyles.wrapper + "1", //get first mail
		content: "Read an email by clicking on it ",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	}
];

const mailSequence = [
	{
		target: ".reply-button-tutorial",
		content: "Reply to an email by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-add-people",
		content: "Add more stakeholders into the mail chain by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-actor-0",
		content: "Select the stakeholders by clicking on their names",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-add-actor",
		content:
			"Add the selected stakeholders to the mail chain by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "top",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-add-message",
		content: "Compose your response message by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-select-option-0",
		content: "Select on an option of your choice by clicking on it",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-add-option",
		content: "Add the selected option by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-send-email",
		content: "Send the finished email by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-accept-call",
		content: "Respond to an incoming call by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: "#tutorial-call-step-0",
		content: "Select on an option of your choice by clicking on it",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	},
	{
		target: ".chat-reply-button",
		content: "Respond with the option of your choice by clicking here",
		textAlign: "center",
		disableBeacon: true,
		disableOverlayClose: true,
		hideFooter: true,
		spotlightClicks: true,
		placement: "bottom",
		styles: {
			options: {
				zIndex: 10000
			}
		}
	}
];

export { tutorialSequence, mailSequence };



// WEBPACK FOOTER //
// /src/constants/tutorialSequence.js